export default "__VITE_ASSET__RiUYlI$9__"